<template>
  <div class="season-pass-lock-panel">
    <div class="bg">
      <div class="text1 to-center-abs">Level</div>
      <div class="text2 to-center-abs">{{ levelNumber }}</div>
    </div>
    <div
      class="unlock-button to-center-abs"
      :class="{ disabled: unlockInFlight }"
      @click="onUnlockClick"
    >
      <div class="button-text1 to-center-abs">
        {{ $t("seasonpass.level.unlock.headline") }}
      </div>
      <div class="button-text2 to-center-abs">
        <span class="position-relative">
          <template v-if="payOfferBadge">
            <img :src="payOfferBadge" alt="offer" class="offer-badge-icon" />
          </template>
          <template v-else-if="crownCost > 0">
            {{ formatNumber(crownCost) }}
            <BaseAsset asset="secondary" class="crown-icon"></BaseAsset>
          </template>
          <template v-else-if="goldCost > 0">
            {{ formatNumber(goldCost) }}
            <BaseAsset asset="primary" class="gold-icon"></BaseAsset>
          </template>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "SeasonPassLockPanel",
  components: { BaseAsset },
  props: {
    level: {
      type: Object,
      required: true,
    },
    unlockInFlight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    crownCost() {
      return Number(this.level && this.level.crowns) || 0;
    },
    goldCost() {
      return Number(this.level && this.level.gold) || 0;
    },
    levelNumber() {
      return (this.level && this.level.level) || "";
    },
    payOfferBadge() {
      const offer = this.level && this.level.pay_offer;
      return (offer && offer.badge_image_path_full) || "";
    },
  },
  methods: {
    onUnlockClick() {
      if (this.unlockInFlight) return;
      this.$emit("unlock-level", this.level);
    },
  },
};
</script>

<style scoped lang="scss">
.season-pass-lock-panel {
  position: relative;
  width: 193px;
  height: 403px;
  display: inline-grid;
  margin-top: 35px;
  margin-left: 30px;

  .bg {
    width: 195px;
    height: 379px;
    background: url(~@/assets/img/events/winter-bonus-jagd/info-panel-level-lock.png)
      left/100% 100% no-repeat;
  }

  .text1 {
    top: 110px;
    font-size: 24px;
  }

  .text2 {
    top: 140px;
    font-size: 32px;
  }

  .unlock-button {
    top: 200px;
    width: 143px;
    height: 95px;
    background: url(~@/assets/img/events/winter-bonus-jagd/btn-unlock-level.png)
      left/100% 100% no-repeat;
    z-index: 2;
    cursor: pointer;

    &.disabled {
      pointer-events: none;
      opacity: 0.6;
    }

    &:hover {
      background: url(~@/assets/img/events/winter-bonus-jagd/btn-unlock-level-down.png)
        left/100% 100% no-repeat;
    }

    .button-text1 {
      top: 10px;
      font-size: 18px;
      width: 100%;
      line-height: 1.1;
    }

    .button-text2 {
      top: 50px;
      font-size: 24px;
      padding-right: 40px;

      .crown-icon {
        position: absolute;
        right: -40px;
        top: 0;
        width: 40px;
        height: 34px;
      }

      .gold-icon {
        position: absolute;
        right: -40px;
        top: 0;
        width: 34px;
        height: 34px;
      }

      .offer-badge-icon {
        width: 48px;
        height: 48px;
        object-fit: contain;
        margin-left: 40px;
        margin-top: -25px;
      }
    }
  }
}
</style>
